export const URL_ALIAS = window.Config.URL_ALIAS;
export const CONTEXT_PATH = window.Config.CONTEXT_PATH || '';

export const STATIC_MEDIA_URL = window.Config.STATIC_MEDIA_URL;

export const BACKEND_URL = window.Config.BACKEND_URL;
export const DISCUSSIONS_URL = window.Config.DISCUSSIONS_URL;
export const DOWNLOAD_URL = window.Config.DOWNLOAD_URL;
export const CDN_URL = window.Config.CDN_URL;
export const CMS_URL = window.Config.CMS_URL;
export const OPENSALT_URL = window.Config.OPENSALT_URL;
export const WEB_SERVER_URL = window.Config.WEB_SERVER_URL;
export const BACKOFFICE_URL = window.Config.BACKOFFICE_URL;
export const PRESENCE_URL = window.Config.PRESENCE_URL;

export const LAE_URL = window.Config.LAE_URL;

export const RABBIT_CONFIG = window.Config.RABBIT_CONFIG;

export const RABBIT_VH = null;

export const GOOGLE_CLIENT_ID = window.Config.GOOGLE_CLIENT_ID;
export const GOOGLE_AUTHORIZATION_URL = window.Config.GOOGLE_AUTHORIZATION_URL;
export const GOOGLE_VALIDATE_TOKEN_URL = window.Config.GOOGLE_VALIDATE_TOKEN_URL;
export const GOOGLE_PROFILE_URL = window.Config.GOOGLE_PROFILE_URL;
export const GOOGLE_REDIRECT_URI = window.Config.GOOGLE_REDIRECT_URI;
export const AZURE_APPLICATION_ID = window.Config.AZURE_APPLICATION_ID;

export const DD_CLIENT_ENABLED = window.Config.DD_CLIENT_ENABLED;
export const DD_CLIENT_TOKEN = window.Config.DD_CLIENT_TOKEN;
export const DD_CLIENT_ENV = window.Config.DD_CLIENT_ENV;
export const DD_CLIENT_SERVICE = window.Config.DD_CLIENT_SERVICE;
export const DD_CLIENT_SAMPLE_RATE = window.Config.DD_CLIENT_SAMPLE_RATE;

export const NETEX_INFRA = window.Config.NETEX_INFRA;
export const GOOGLE_MEET_CLIENT_ID = window.Config.GOOGLE_MEET_CLIENT_ID;
export const SHOW_LOGIN_FOOTER = window.Config.SHOW_LOGIN_FOOTER;
export const EMPTY_LESSON_ID = window.Config.EMPTY_LESSON_ID;
export const GTM_ID = window.Config.GTM_ID;
